export default "__VITE_ASSET__DliDnw6G__"